import { GetCsvExcelAccountsApi } from "@/features/accounts/csv-excel/services/get-accounts-api";
import { GetCsvExcelAccountsRequestModel } from "@/features/accounts/csv-excel/services/get-accounts-model";

/// CsvExcel一覧取得処理
export class GetCsvExcelAccountsService {
  private getCsvExcelAccountsApi = new GetCsvExcelAccountsApi();

  /**
   * CsvExcel一覧取得API実行
   */
  public async getCsvExcelAccounts(param: GetCsvExcelAccountsRequestModel) {
    return await this.getCsvExcelAccountsApi.getCsvExcelAccounts(param);
  }
}
